export const API_PARAM = {
  IDENTITY_TENANTS: "core/identity/tenants",
  IDENTITY_CONFIG: "core/identity/config",
  IDENTITY_CURRENT: "core/identity/token",
  IDENTITY_LOGOUT: "core/identity/logout",
  IDENTITY_AVATAR: "core/identity/avatar",
  BASELINE_IDENTITY: "baseline/identity/token",
  NOTIFICATIONS: "notifications",
  NONCE_TOKEN: "core/nonce/token",
  ACTIONS: "core/actions",
  TENANT_SETTINGS: "baseline/tenant-settings",
  BENCHMARK_FILTERING_CONFIG: "baseline/data/benchmark-filterings/config",
  BENCHMARK_FILTERING_DATA: "baseline/data/benchmark-filterings",
  USER_DETAILS: "core/user-details",
  MAINTENANCE: "core/content/maintenance",
  TENANT_CONFIGURATION: "baseline/tenant-configs",
  SAVED_QUERIES: "baseline/data/saved-queries",
  SAVED_QUERIES_BY_GRID_NAME: "baseline/data/saved-queries/gridname",  
  EXPORT: "baseline/reports/{id}",
  EXPORT_ERRORS: "admin/datasets/report/{id}",
  ASSET_UPLOAD: "content-studio/energize/asset/upload?skillPathId={id}",
  BACKGROUNDS:"content-studio/energize/backgrounds",
};
